<template>
  <div>
    <div :class="{ 'MultipleUploadClass': position  === 'form' }" style="display: flex;align-items: center;">
      <div v-for="item in efileData" :key="item.index" :title="item.mhfilesFileDname" class="listName">
        <single-upload-buttons v-if="item.mhfilesFilePath" :mObj="item" mType="M" :fileProps="fileProps" :disabled="disabled" :formDisabled="formDisabled" :position="position"></single-upload-buttons>
      </div>
      <div v-if="efileDLen < mhfileLimit">
        <single-upload-buttons :mObj="mObj" mType="M" :fileProps="fileProps" :disabled="disabled" :formDisabled="formDisabled" :position="position"></single-upload-buttons>
      </div>
      <el-form>
        <div style="position: relative;width: 20px;height: 20px">
          <div class="info_right" v-show="efileDLen > 0">
            <el-popover placement="bottom" trigger="hover" @show="infoClass = 'el-icon-caret-top'" @hide="infoClass = 'el-icon-caret-bottom'">
              <el-table :data="efileData" :row-class-name="rowClassName" @selection-change="handleSelectionChange">
                <el-table-column width="10" type="index"></el-table-column>
                <el-table-column width="35" type="selection" align="center"></el-table-column>
                <el-table-column width="160" property="mhfilesFileDname" show-tooltip-when-overflow>
                  <template slot="header" slot-scope='{}'>
                    <el-button type="primary" plain size="mini" style="padding: 3px" @click="handleClickAll" :disabled="mfileViewOnly || selectData.length === 0">下载选中文件【{{selectData.length}}】</el-button>
                  </template>
                </el-table-column>
                <el-table-column width="25">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" icon="el-icon-download" @click="handleClick(scope.row)" :disabled="mfileViewOnly"></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div slot="reference">
                <i :class="infoClass"></i>
              </div>
            </el-popover>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import SingleUploadButtons from '@/components/base/SingleUploadButtons.vue'
export default {
  name: 'MultipleUploadButtons',
  props: ['formDisabled', 'mainObj', 'fileProps', 'position', 'disabled'],
  data () {
    return {
      efileData: [],
      efileDLen: 0,
      mObj: {},
      infoClass: 'el-icon-caret-bottom',
      selectData: []
    }
  },
  components: {
    SingleUploadButtons
  },
  computed: {
    mfileViewOnly () {
      if (this.mfilePropsObj.viewOnly) {
        return true
      } else {
        return false
      }
    },
    mfilePropsObj () {
      return JSON.parse(this.fileProps)
    },
    mhfilesCodeProps () {
      if (!this.mainObj) {
        return ''
      } else {
        return this.mainObj[this.mfilePropsObj.mhfilesCode]
      }
    },
    mhfileLimit () {
      if (!this.mainObj) {
        return 0
      } else {
        return this.mainObj[this.mfilePropsObj.mhfileLimit] || this.mfilePropsObj.mhfileLimit
      }
    },
    rootDirCodeM () {
      if (!this.mfilePropsObj.rootDirCode) {
        return 'SYSCFG_EDOC'
      } else {
        if (this.mfilePropsObj.rootDirCode.indexOf('$') === 0) {
          return this.mainObj[this.mfilePropsObj.rootDirCode.replaceAll('$', '')]
        } else {
          return this.mfilePropsObj.rootDirCode
        }
      }
    },
    rootDirFieldM () {
      if (!this.mfilePropsObj.rootDirField) {
        return 'sys_char1'
      } else {
        if (this.mfilePropsObj.rootDirField.indexOf('$') === 0) {
          return this.mainObj[this.mfilePropsObj.rootDirField.replaceAll('$', '')]
        } else {
          return this.mfilePropsObj.rootDirField
        }
      }
    }
  },
  methods: {
    handleClick (row) {
      const that = this
      that.viewPdfM(row)
    },
    handleClickAll () {
      const that = this
      if (that.selectData.length === 0) {
        return
      }
      that.selectData.forEach(v => {
        that.viewPdfM(v)
      })
    },
    handleSelectionChange (val) {
      const that = this
      that.selectData = val
    },
    viewPdfM: async function (val) {
      const that = this
      const p = {
        rootDirCode: that.rootDirCodeM,
        rootDirField: that.rootDirFieldM,
        filePath: val.mhfilesFilePath,
        fileName: val.mhfilesFileName,
        reConvert: false
      }
      const url = '/edoc/responseEdocFile'
      that.$emit('updateUpDown', 'down', 0)
      that.$http.post(url, p, {
        responseType: 'blob',
        onDownloadProgress (progress) {
          if (progress.lengthComputable) {
            const val = (progress.loaded / progress.total * 100).toFixed(0) / 100
            that.$emit('updateUpDown', 'down', val)
            if (val >= 99.999) {
              that.$emit('updateUpDown', '', 0)
            }
          }
        }
      }).then((response) => {
        const content = response.data
        const blob = new Blob([content])
        const aLink = document.createElement('a')
        const url = URL.createObjectURL(blob)
        if ('download' in aLink) {
          aLink.download = val.mhfilesFileDname
          aLink.style.display = 'none'
          aLink.href = url
          document.body.appendChild(aLink)
          aLink.click()
          URL.revokeObjectURL(aLink.href)
          document.body.removeChild(aLink)
        } else {
          navigator.msSaveBlob(blob, val.mhfilesFileDname)
        }
      })
    },
    rowClassName: function ({ row, rowIndex }) {
      if (!row.mhfilesFilePath) {
        this.efileData.splice(rowIndex, 1)
        this.updateMhfilesDetData(row, 'delete')
      }
    },
    updateMhfilesDetData: async function (data, action) {
      const that = this
      data.mhfilesCrtDate = that.$Any.getCurrentDate('yyyy-MM-dd HH:mm:ss')
      const p = {
        action: action,
        data: data
      }
      const { data: res } = await that.$http.post('/edoc/postMhfilesDet', p)
      if (res === 1) {
        if (action === 'insert') {
          that.efileData.push(data)
          await that.initialize()
        }
      }
    },
    initialize: async function () {
      const that = this
      if (that.efileDLen >= that.mhfileLimit) {
        return
      }
      if (!that.mainObj[that.mfilePropsObj.mhfilesCode]) {
        return
      }
      const para = {
        lineField: 'mhfiles_line',
        table: 'mhfiles_det',
        condition: {
          mhfiles_code: that.mainObj[that.mfilePropsObj.mhfilesCode]
        }
      }
      const { data: res } = await this.$http.post('/users/getNextLineByTable', para)
      if (res) {
        that.mObj = {
          mhfilesCode: that.mainObj[that.mfilePropsObj.mhfilesCode],
          mhfilesLine: res,
          mhfilesRefNbr: that.mainObj[that.mfilePropsObj.mhfilesRefNbr],
          mhfilesRefLine: that.mainObj[that.mfilePropsObj.mhfilesRefLine] || 0,
          mhfilesRefLot: that.mainObj[that.mfilePropsObj.mhfilesRefLot] || '',
          mhfilesFilePath: '',
          mhfilesFileName: '',
          mhfilesFileDname: '',
          mhfilesFileProp1: '',
          mhfilesFileProp2: '',
          mhfilesFileProp3: '',
          mhfilesCrtBy: that.$Any.getCurrentUser(),
          mhfilesCrtDate: ''
        }
      }
    }
  },
  watch: {
    mainObj: {
      async handler (newValue, oldValue) {
        const that = this
        that.mObj.mhfilesRefNbr = that.mainObj[that.mfilePropsObj.mhfilesRefNbr]
        that.mObj.mhfilesRefLine = that.mainObj[that.mfilePropsObj.mhfilesRefLine] || 0
        that.mObj.mhfilesRefLot = that.mainObj[that.mfilePropsObj.mhfilesRefLot] || ''
      },
      immediate: true,
      deep: true
    },
    mhfilesCodeProps: {
      async handler (newValue, oldValue) {
        const that = this
        if (!newValue) {
          that.efileData = []
          that.mObj = {
            mhfilesCode: newValue,
            mhfilesLine: 10,
            mhfilesRefNbr: that.mainObj[that.mfilePropsObj.mhfilesRefNbr],
            mhfilesRefLine: that.mainObj[that.mfilePropsObj.mhfilesRefLine] || 0,
            mhfilesRefLot: that.mainObj[that.mfilePropsObj.mhfilesRefLot] || '',
            mhfilesFilePath: '',
            mhfilesFileName: '',
            mhfilesFileDname: '',
            mhfilesFileProp1: '',
            mhfilesFileProp2: '',
            mhfilesFileProp3: '',
            mhfilesCrtBy: that.$Any.getCurrentUser(),
            mhfilesCrtDate: ''
          }
          return
        }
        const para = {
          mhfilesCode: newValue
        }
        const { data: res } = await that.$http.post('/edoc/getMhfilesDetByCode', para)
        if (res.data) {
          that.efileData = res.data
          await that.initialize()
        }
      },
      immediate: true,
      deep: true
    },
    mObj: {
      handler (newValue, oldValue) {
        const that = this
        if (newValue.mhfilesCode) {
          if (!that.mainObj[that.mfilePropsObj.mhfilesCode]) {
            that.mainObj[that.mfilePropsObj.mhfilesCode] = newValue.mhfilesCode
          }
          if (newValue.mhfilesFilePath) {
            that.updateMhfilesDetData(Object.assign({}, newValue), 'insert')
          }
        }
      },
      deep: true
    },
    efileData: {
      handler (newValue, oldValue) {
        const that = this
        that.efileDLen = that.efileData.length
      },
      deep: true
    }
  },
  created () {},
  beforeMount () {},
  mounted () {}
}
</script>

<style lang="less" >
  .MultipleUploadClass {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    width: calc(100% - 2px);
    min-width: 64px;
    min-height: 64px;
    flex-wrap: wrap;
  }
  .el-icon-caret-top {
    color: #0a84ff;
    font-size: 20px;
  }
  .info_right {
    cursor: pointer;
    font-size: 20px;
    padding-left: 5px;
    width: 20px;
    height: 20px;
  }
  .listName {
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
